<template>
	
  <div class="home">
<div class="works-ban">
	
		<p> 
會員中心              </p>
	</div>
   <div class="mem-full">

 <Center title='3' />

<div class="mem-con">
	<div class="mem-jin">
		會員中心 / <b>收貨地址</b>

	</div>
	<div class="address">
		<div class="men-l1">
			<div class="re-tit">
					  <div class="dick"> <h4>保存的收貨地址</h4>你已經創造了 {{news.length}} 收貨地址</div><div class="r-button" @click="add=true">添加送貨地址</div>
			</div>
			<div class="re-con">
				<ul>
					<li v-for="item in news">
						<div class="l1">
							<span>{{item.name}}</span><span class="add-def" v-if="item.if_default==1">默認地址</span><div v-else @click="kand(item.id)"><img src="../../assets/bit.png"></div>
						</div>
						<div class="l2">
							{{item.areaName}}
							{{item.address}}
							
						</div>
						<div class="l3">
							<span>	{{item.phone}}</span><div class="k-button" @click="revise(item.id)">修訂</div>
						</div>
					</li>
				
		
					<div class="clear"></div>
				</ul>
			</div>
		</div>
		
	</div>

	<div class="login-r1" v-if="add">
	<div class="re-tit add-ship">
		<h4>{{tit}} 收貨地址</h4>
		
		
	</div>
	<div class="add-for">
	
	<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px"  label-position="top"  size="mini">
		<el-row :gutter="20">
			 <el-col :span="12">
	  <el-form-item label="名字" prop="first_name">
	    <el-input v-model="ruleForm.first_name" placeholder="請填寫真實姓名"></el-input>
	  </el-form-item>
	  </el-col>
	  <el-col :span="12">
	  <el-form-item label="姓" prop="last_name">
	    <el-input v-model="ruleForm.last_name" placeholder="請填寫真實姓名"></el-input>
	  </el-form-item>
	  </el-col>
	 </el-row>
	 

	 
	 <el-row :gutter="20">
	 			 <el-col :span="12">
	  <el-form-item label="電話" prop="phone">
	    <el-input v-model="ruleForm.phone"></el-input>
	  </el-form-item>
	  </el-col>
	  <el-col :span="12">
	  <el-form-item label="昵稱" prop="nickname" >
	    <el-input v-model="ruleForm.nickname"></el-input>
	  </el-form-item>
	  </el-col>
	 </el-row>
	 
	 
	 <el-row :gutter="20">
	 			 <el-col :span="12">
	<el-form-item label="國家/地區"  prop="country">
	   <el-select v-model="ruleForm.country" placeholder="請填寫國家"   @change="country">
	     <el-option v-for="item in sun" :label="item.DESCRIPTION" :value="item.DESCRIPTION"></el-option>
		  
	   </el-select>
	 </el-form-item>
	  </el-col>
	  <el-col :span="12">
	  <el-form-item label="ID" prop="identity_id">
	    <el-input v-model="ruleForm.identity_id" placeholder="大陸香港澳門和臺灣必須填寫身份證號碼"></el-input>
	  </el-form-item>
	  </el-col>
	 </el-row>
	 <el-row :gutter="20">
	 			 <el-col :span="8">
	  <el-form-item label="省" prop="province">
	    <el-input v-model="ruleForm.province"></el-input>
	  </el-form-item>
	  </el-col>
	  <el-col :span="8">
	  <el-form-item label="城鎮/都市" prop="city">
	    <el-input v-model="ruleForm.city"></el-input>
	  </el-form-item>
	  </el-col>
	  <el-col :span="8">
	  <el-form-item label="郵遞區號" prop="postcode">
	    <el-input v-model="ruleForm.postcode"></el-input>
	  </el-form-item>
	  </el-col>
	 </el-row>
	 <el-row :gutter="20">
	 			 <el-col :span="24" >
	  <el-form-item label="地址行" prop="address_line">
	    <el-input v-model="ruleForm.address_line"></el-input>
	  </el-form-item>
	  </el-col>
	
	 </el-row>


	 <el-row>
	  <el-form-item > 
	  <el-switch active-color="#050505" @change="full" v-model="moren"></el-switch><span class="add-set">設為默認地址</span>
	  </el-form-item>
	  </el-row>
	 <el-row :gutter="20">

	 </el-row>
	 
	<div class="h-button" @click="submitForm('ruleForm')">保存</div>
	 
	 
	  </el-form-item>
	</el-form>
	
	</div>
	</div>

	
</div>
   </div>

    </div>
</template>
<script>

import Center from '@/components/center/center'

export default {
  components: {
   Center
  },
  data() {
    return {
	ind:2,
		page:1,
		pagenum:100,
		moren:false,
		sun:'',
		add:false,
		tit:'添加',
		news:'',
		ins:false,
		sub:{
			id:0,
           	first_name:'',
           	last_name:'',
         
           	phone:'',
           	nickname:'',
           	country:'',
           	identity_id:'',
           	address_line:'',
           	province:'',
           	city:'',
           	postcode:'',
			moren: 0,
          
               
                 },
           ruleForm: {
			id:0,
           	first_name:'',
           	last_name:'',
         
           	phone:'',
           	nickname:'',
           	country:'',
           	identity_id:'',
           	address_line:'',
           	province:'',
           	city:'',
           	postcode:'',
			moren: 0,
          
               
                 },
                 rules: {
                 	
                 	   first_name: [
                 	    { required: true, message: '請填寫名字', trigger: 'blur' },
                 ],last_name: [
                 	    { required: true, message: '請填寫姓氏', trigger: 'blur' },
                 ],phone: [
                 	    { required: true, message: '請填寫電話', trigger: 'blur' },
                 ],country: [
                 	    { required: true, message: '請填寫國家', trigger: 'change' },
                 ],address_line: [
                 	    { required: true, message: '請填寫地址行1', trigger: 'blur' },
                 ],province: [
                 	    { required: true, message: '請填寫省份', trigger: 'blur' },
                 ],city: [
                 	    { required: true, message: '請填寫都市', trigger: 'blur' },
                 ],postcode: [
                 	    { required: true, message: '請填寫郵遞區號', trigger: 'blur' },
                 ],nickname: [
                 	    { required: true, message: '請填寫暱稱', trigger: 'blur' },
                 ],identity_id:[]
                  
                   }
          };
  },  mounted() {
	  
	
 this.ind = this.$route.query.ind
		this.sandMate();
		this.sandCase();
	
		},methods: {
			
		 submitForm(formName) {
		
		// if(this.ruleForm.country=='中国'||this.ruleForm.country=='中国香港'||this.ruleForm.country=='中国台湾'||this.ruleForm.country=='中国澳门'){
		// 					  if(this.ruleForm.identity_id==''){
		// 						   this.ins=true
		// 					  }else{
		// 									    this.ins=false
		// 								  }
						
		// }
		  
		//   if(this.ins){
		// 	  this.$message.error("請填寫身份證號");
		// 	  return
		//   }
			      
		        this.$refs[formName].validate((valid) => {
		          if (valid) {
		         this.$axios({
		           method: "post",
		           url: "service.php?action=userAddress_add",
		           data: this.ruleForm,  
		         }).then((res) => {
		         	let data=res.data;
		         			
		         	if(data.code==1){
						
					this.$message.success(data.message);
					this.sandMate()
					this.ruleForm.id=0
					this.add=false
					this.tit='添加'
					this.ruleForm=this.sub
					if(this.ind==1){
						this.$router.back();
					}
		         	}else{  
						this.$message.error(data.message);
						      
					}
		          
		         });
				 
				 
		          } else {
		           
		            return false;
		          }
		        });
		      },
			  full(){
				  if(this.moren){
					  this.ruleForm.moren= 1
				  }else{
					   this.ruleForm.moren= 0
				  }
			
			  },
			 kand(id){
			   	this.$axios({
			   	  method: "post",
			   	  url: "service.php?action=userAddress_delete",
			   	  data: {id:id},  
			   	}).then((res) => {
			   		let data=res.data;
			   	
			   		if(data.code==1){
			   			
			   		this.$message.success(data.message);
			   		this.sandMate()
			   				  
			   		}else{  
			   			this.$message.error(data.message);
			   			      
			   		}
			   	 
			   	});
			   
			   },
			   revise(id){
				   this.ruleForm.id=id;
				   this.tit='修訂'
				    this.add=true
			     	this.$axios({
			     	  method: "post",
			     	  url: "service.php?action=userAddress_detail",
			     	  data: {id:id},  
			     	}).then((res) => {
			     		let data=res.data;
			     	
			     		if(data.code==1){
			     			
			     	this.ruleForm=data.data
			     				  
			     		}
			     	 
			     	});
			     
			     },
			 sandCase(){
			  	this.$axios({
			  	  method: "post",
			  	  url: "service.php?action=userAddress_country",
			  	  data: {},  
			  	}).then((res) => {
			  		let data=res.data;
			  	
			  		if(data.code==1){
			  			this.sun=data.data;
			  		}
			  	 
			  	});
			  
			  },
			country(){
							  if(this.ruleForm.country=='中国'||this.ruleForm.country=='香港(中国)'||this.ruleForm.country=='台湾(中国)'||this.ruleForm.country=='澳门(中国)'){
								  
								  this.rules.identity_id=[{ required: true, message: '請填寫身份證號', trigger: 'blur' }]
								  
								  
								  // if(this.ruleForm.identity_id==''){
									 //   this.ins=true
								  // }else{
										// 		    this.ins=false
										// 	  }
							
							  }else{
								  this.rules.identity_id=[]
							  }
			},
			  sandMate(){
			  	this.$axios({
			  	  method: "post",
			  	  url: "service.php?action=userAddress_lists",
			  	  data: {page:this.page,pagenum:this.pagenum},  
			  	}).then((res) => {
			  		let data=res.data;
			  
			  		if(data.code==1){
			  	
			  							
			  			this.news=data.data;
			  			
			  			
			  		}
			  	 
			  	});
			  
			  },
		      resetForm(formName) {
		        this.$refs[formName].resetFields();
		      }
		}
};
</script>
<style lang="scss" scoped>
	
	.h-button{
			text-align: center;
			cursor: pointer;
			width: 185px;
			padding: 0 50px;
			height: 50px;
			line-height: 50px;
			background: #000;
			color: #FFFFFF;
			margin-top: 30px;
		}
		.h-button:hover{
			background-color: #333333;
		}
		
		.r-button{
				text-align: center;
				cursor: pointer;
				padding: 0 20px;
				height: 30px;
				line-height: 30px;
				background: #000;
				color: #FFFFFF;
				margin-right: 20px;
			
			}
			.r-button:hover{
				background-color: #333333;
			}
	.login{
		padding: 20px 0;
		.re-tit{
			line-height: 50px;
			display: flex;
			h4{
				font-size: 26px;
				
			}
			margin-bottom: 20px;
		}
	}	
.login-r1{

}
.login-r2{
	width:490px;

	padding: 50px;
	float: left;

}
.address{
	.re-con{
		li{
			width: 374px;
			height: 190px;
			background: #F8F8F8;
			border: 1px solid #D2D2D2;
			float: left;
			margin-right: 23px;
			margin-bottom: 20px;
			.l1{
				display: flex;
				height: 50px;
				justify-content: space-between;
				align-items: center;
				border-bottom: 1px dotted #DDDDDD;
				padding: 0 20px;
			}
.l2{
			
				height: 50px;
				
				border-bottom: 1px dotted #DDDDDD;
				padding:15px 20px;
			}
			.l3{
				display: flex;
				height: 50px;
				justify-content: space-between;
				align-items: center;
		
				padding: 0 20px;
				.k-button{
					border: 1px solid #D2D2D2;
					padding:8px 20px;
					cursor: pointer;
				}
			}
		}
		.plus{
			display: flex;
			flex-direction:column ;
			justify-content: center;
			align-items: center;
			img{
				width: 33px;
				height: 33px;
			}
		}
	}
}

	.works-ban{
		font-family: 'Arial-BoldMT';
		padding-top: 15px;
		background: #0A0A0A;
		height: 57px;
		color: #FFFFFF;
		text-align: center;
		line-height: 40px;
		font-size: 18px;
		font-weight: bold;
		h2{
			font-size: 43px;
		}
		span{
			margin: 20px;
			color: #B5B5B5;
		}
		.acts{
			color: #FFFFFF;
			font-weight: bolder;
		}
	}

.mem-full{
	display: flex;
	width: 1200px;
	margin: 20px auto;
}

.mem-con{
	flex: 1;
	margin-left: 20px;
	.men-l1{
		border: 1px solid #D2D2D2;
		.re-tit{
			display: flex;
			justify-content: space-between;
			align-items: center;
			line-height: 50px;
			border-bottom: 1px solid #D2D2D2;
			h4{
				margin-left: 20px;
				margin-right: 10px;
			}
			.dick{
				display: flex;
			}
		}
		.l1{
			position: relative;
			.add-def{
				width: 105px;
				height: 33px;
				line-height: 33px;
				text-align: center;
				background: #0A0A0A;
				color: #FFFFFF;
				position: absolute;
				top: 0;
				right: 20px;
			}
		}
		.re-con{
			padding: 20px;
		}
	}
}
.add-for{
padding: 30px;
	background: #F8F8F8;
	border: 1px solid #D2D2D2;
	

}
.add-ship{
	margin: 20px 0;
}
.add-set{
	margin-left: 10px;
}
</style>